import { replace } from 'react-router-redux';

import apiSubmitPetition from '../../utils/petition/petitionApi';

import {
    ACTION_COMPLETED_LOCAL_REP,
    EMAIL_COLLECTED,
    onFinishMultiAction
} from '../Widget/actions';

export const PETITION_SUBMITTING = 'PETITION_SUBMITTING';
export const PETITION_SUCCESS = 'PETITION_SUCCESS';
export const PETITION_INITIATED = 'PETITION_INITIATED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const PETITION_ERROR = 'PETITION_ERROR';

let toasterTimeout = null;

export const onPetitionComplete = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    isMultiActionsCard,
    actionIdentifier,
    thankYouText,
    thankYouTitle,
    confirmationTitle,
    useLocalRepresentative,
    localRepresentativeState,
    skipEndCard
) => dispatch => {
    dispatch({
        type: PETITION_SUBMITTING,
        payload: true
    });

    return apiSubmitPetition(
        apiRequestData,
        actionCompletedTime,
        values,
        localRepData,
        useLocalRepresentative
    )
        .then(data => {
            dispatch({
                type: PETITION_SUCCESS,
                payload: {
                    ...data,
                    actionIdentifier,
                    thankYouText,
                    confirmationTitle
                }
            });

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: {
                    thankYouText,
                    thankYouTitle,
                    useLocalRepresentative,
                    localRepresentativeState
                }
            });

            dispatch({
                type: ACTION_COMPLETED_LOCAL_REP
            });

            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }

            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else if (!skipEndCard) {
                dispatch(replace('/petition/success'));
            }

            dispatch({
                type: PETITION_SUBMITTING,
                payload: false
            });
        })
        .catch(() => {
            dispatch({
                type: PETITION_ERROR,
                payload:
                    'There was an error while submitting your form! Please try again later!'
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: PETITION_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: PETITION_SUBMITTING,
                payload: false
            });
        });
};



// WEBPACK FOOTER //
// ./src/containers/Petition/actions.js